/**
 * Formats an employee name with their extension number.
 * Returns "Name (ext)" if extension exists, otherwise just the name.
 */
export const formatEmployeeNameWithExtension = (
    name: string | null | undefined,
    extension: string | null | undefined,
): string => {
    if (!name) {
        return "";
    }
    if (extension && extension.trim() !== "") {
        return `${name} (${extension})`;
    }
    return name;
};
